<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="用户代码:" prop="dm">
                        <el-input
                        v-model="queryParams.dm"
                        placeholder="请输入"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="用户姓名:" prop="xm">
                        <el-input
                        v-model="queryParams.xm"
                        placeholder="请输入"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="用户身份:" prop="yhsf">
                        <el-select v-model="queryParams.yhsf" placeholder="请选择" size="small">
                            <el-option
                                v-for="(dict,index) in yhsfOptions"
                                :key="index"
                                :label="dict.yhsf"
                                :value="dict.yhsf"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="工作部门:" >
                        <el-select v-model="queryParams.gzbm" placeholder="请选择" size="small">
                            <el-option
                                v-for="(dict,index) in gzbmOptions"
                                :key="index"
                                :label="dict.gzbm"
                                :value="dict.gzbm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态:" prop="zt">
                        <el-select v-model="queryParams.zt" placeholder="请选择" size="small" style="width:120px;">
                            <el-option  label="全部" value=""/>
                            <el-option  label="正常" value="true"/>
                            <el-option  label="停用" value="false"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                        <el-button type="danger" v-if="xz=='1'" icon="el-icon-plus" size="small" @click="handleAdd">新增</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="userList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="代码" align="center" prop="dm" />
                    <el-table-column label="姓名" align="center" prop="xm" />
                    <el-table-column label="性别" align="center" prop="xb" />
                    <el-table-column label="用户身份" align="center" prop="yhsf" />
                    <el-table-column label="执法证号" align="center" prop="zfzh" />
                    <el-table-column label="状态" align="center" prop="zt" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.zt == 'True'">正常</span>
                            <span v-else>停用</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="工作部门" align="center" prop="gzbm" />
                    <el-table-column label="工作职务" align="center" prop="gzzw" />
                    <el-table-column label="主管区域" align="center" prop="zgqy" />
                    <el-table-column label="主管范围" align="center" prop="zgfw"  :formatter="zgfwFormat" />
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="140" >
                        <template slot-scope="scope">
                            <!-- <el-button
                            size="small"
                            type="text"
                            @click="handleEdit(scope.row)"
                        >查看</el-button> -->
                        <el-button 
                            size="small"
                            type="text"
                            @click="handleEdit(scope.row)"
                        >编辑</el-button>
                        <el-button v-if="sc=='1'"
                            size="small"
                            type="text"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>
        <el-dialog title="用户信息" :visible.sync="open" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <div class="nr">
                <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    <el-row>
                        <el-col :span="12" >
                    <el-form-item label="用户代码:" prop="dm">
                        <el-input :disabled="form.id?true:false" v-model="form.dm" size="small"  clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                        </el-col>
                        <el-col :span="12" >
                    <el-form-item label="用户姓名:" prop="xm">
                        <el-input v-model="form.xm" clearable placeholder="请输入" size="small" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="性别:" prop="xb">
                        <el-select v-model="form.xb" placeholder="请选择性别" clearable size="small">
                            <el-option  label="男" value="男"/>
                            <el-option  label="女" value="女"/>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="用户身份:" prop="yhsf">
                        <el-select v-model="form.yhsf" placeholder="请选择" size="small">
                            <el-option
                                v-for="(dict,index) in yhsfOptions"
                                :key="index"
                                :label="dict.yhsf"
                                :value="dict.yhsf"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="执法证号:" prop="zfzh">
                        <el-input v-model="form.zfzh" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="身份证号:" prop="sfzh">
                        <el-input v-model="form.sfzh" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="工作部门:" >
                        <el-select v-model="form.gzbm" placeholder="请选择" size="small">
                            <el-option
                                v-for="(dict,index) in gzbmOptions"
                                :key="index"
                                :label="dict.gzbm"
                                :value="dict.gzbm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="工作职务:" prop="gzzw">
                        <el-input v-model="form.gzzw" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="主管区域:" prop="zgqy">
                        <!-- <el-input v-model="form.zgqy" clearable size="small" placeholder="请输入" ></el-input> -->
                        <el-select v-model="form.zgqy" placeholder="请选择" size="small">
                            <el-option
                                v-for="(dict,index) in zgqyOptions"
                                :key="index"
                                :label="dict.zgqy"
                                :value="dict.zgqy"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="主管范围:" prop="zgfw">
                        <el-select v-model="form.zgfw" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in zylbOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="状态:" prop="zt">
                        <el-select v-model="form.zt" placeholder="请选择" size="small">
                            <el-option  label="正常" value="True"/>
                            <el-option  label="停用" value="False"/>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="电子邮箱:" prop="em">
                        <el-input v-model="form.em" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="联系手机:" prop="sj1">
                        <el-input v-model="form.sj1" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="出生日期:" prop="csrq">
                        <el-date-picker size="small" clearable
                            v-model="form.csrq"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                        <el-col :span="12" >
                    <el-form-item label="个人头像:" prop="img">
                        <el-upload
                                class="avatar-uploader"
                                action="#"                 
                                :before-upload="beforeAvatarUpload"
                                :show-file-list="false" 
                                >
                            <img v-if="form.yhimgurl" :src="form.yhimgurl" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <el-button type="primary" @click="onSubmitTp">上传头像</el-button>
                    </el-form-item>
                </el-col>
                    </el-row>
                </el-form>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button type="primary" size="small" @click="onSubmit('form')">确定</el-button>
                    <el-button size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            cmid:'',
            queryParams:{
                dm:'',
                xm:'',
                yhsf:'',
                gzbm:'',
                zt:'全部',
                page:1,
                limit:10,
            },
            total:0,
            userList:[],
            open:false,
            pageshow:true,
            yhsfOptions:[],
            gzbmOptions:[],
            qyOptions:[],
            ztOptions:[],
            zylbOptions:[],
            zgqyOptions:[],
            form:{
                id:'',
                xm:'',
                xb:'',
                yhsf:'',
                zfzh:'',
                sfzh:'',
                txdz: '',
                gzbm:'',
                zgqy:'',
                gzzw:'',
                zgfw:'',
                zt:'',
                em:'',
                csrq:'',
                sj1:'',
                yhimgurl:'',
            },
            rules:{
                dm: [
                    { required: true, message: '用户代码不能为空', trigger: 'blur' }
                ],
                xm: [
                    { required: true, message: '用户姓名不能为空', trigger: 'blur' }
                ],
                yhsf: [
                    { required: true, message: '用户身份不能为空', trigger: ['change','blur'] }
                ],
                gzbm: [
                    { required: true, message: '工作部门不能为空', trigger: ['change','blur'] }
                ],
                // zgqy: [
                //     { required: true, message: '主管区域不能为空', trigger: ['change','blur'] }
                // ],
                // zgfw: [
                //     { required: true, message: '主管范围不能为空', trigger: ['change','blur'] }
                // ],
                zt: [
                    { required: true, message: '状态不能为空', trigger: ['change','blur'] }
                ]
            },

            fileName:'',
            files:{},
            imgUrl:'',
            sc: "",
            xg: "",
            xz: "",
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '操作员管理'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.cmid = user.c_mid
        this.baseUrl = user.baseUrl
        axios({
                method: 'post',
                url: this.baseUrl+`/login/getgzbm`,
                data:{
                    gzbm:'',
                    limit:99,
                    page:1
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.data){
                    this.gzbmOptions = res.data.data.list
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            })
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getZylb`,
            data:{
                 "cfxt":""
            },
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zylbOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        axios({
                method: 'post',
                url: this.baseUrl+`/login/getFpqx`,
                data:{
                    yhsf:'',
                    limit:100,
                    page:1
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.data){
                    this.yhsfOptions = res.data.data.list
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            })
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getZgqy`,
            data:{
                cmid:this.cmid
            },
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zgqyOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        this.getList()
    },
    methods: {
        zgfwFormat(row, column) {
            return this.zylbLabel(this.zylbOptions, row.zgfw)
        },
        getList(){
            this.userList = []
            this.total = 0
            this.queryParams.gzbm = this.queryParams.gzbm?this.queryParams.gzbm:'全部'
            this.queryParams.yhsf = this.queryParams.yhsf?this.queryParams.yhsf:'全部'
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getczygl`,
                data:{
                    cmid:this.cmid,
                    dm:this.queryParams.dm,
                    xm:this.queryParams.xm,
                    yhsf:this.queryParams.yhsf,
                    gzbm:this.queryParams.gzbm,
                    zt:this.queryParams.zt,
                    limit:this.queryParams.limit,
                    page:this.queryParams.page
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.data){
                    this.userList = res.data.data.list
                    this.total = res.data.data.total || 0
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            })
        },
        resetQuery(){
            this.queryParams = {
                dm:'',
                xm:'',
                yhsf:'全部',
                gzbm:'全部',
                zt:'全部',
                page:1,
                limit:10,
            }
            this.getList()
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            console.log(val)
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleAdd(){
            this.form = {
                id:'',
                xm:'',
                xb:'',
                yhsf:'',
                zfzh:'',
                sfzh:'',
                txdz: '',
                gzbm:'',
                zgqy:'',
                gzzw:'',
                zgfw:'',
                zt:'',
                em:'',
                csrq:'',
                sj1:'',
                yhimgurl:'',
            }
            this.open = true
        },
        getCheck(){
            console.log(this.checkList)
        },
        handleEdit(row){
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getIdYongxi`,
                data:{
                    id: row.id
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                this.open = true
                if(res.data.code == 0 && res.data.data){
                    this.form = res.data.data
                    if(data.data[0].yhimgurl){
                        this.imgUrl = data.data[0].yhimgurl
                        this.$set(this.form,'yhimgurl','https://dapc1.scqwszfd.cn:8123'+data.data[0].yhimgurl)
                    }
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            }) 
        },
        cancel(){
            this.form = {
                id:'',
                xm:'',
                xb:'',
                yhsf:'',
                zfzh:'',
                sfzh:'',
                txdz: '',
                gzbm:'',
                zgqy:'',
                gzzw:'',
                zgfw:'',
                zt:'',
                em:'',
                csrq:'',
                sj1:'',
                yhimgurl:'',
            }
            this.open = false
        },
        handleChange(file) {
            console.log(file)
            // this.$set(this.form,'yhimgurl',URL.createObjectURL(file.raw));
            // console.log(this.form.yhimgurl)
            
        },
        beforeAvatarUpload(file) {
            console.log(file)
            this.files = file;
            const isJPEG = file.type === 'image/jpeg'
            const isPNG = file.type === 'image/png'
            const isJPG = file.type === 'image/jpg'
            const isGIF = file.type === 'image/GIF'
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!(isJPEG || isPNG || isJPG || isGIF)) {
                this.$message.error('上传图片只能是 JPEG/PNG/JPG/GIF 格式!')
                return false // 返回false不会自动上传
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 10MB!');
                return false // 返回false不会自动上传
            }
            this.fileName = file.name;
            this.$set(this.form,'yhimgurl',URL.createObjectURL(file));
            return false // 返回false不会自动上传
        },
        async onSubmitTp () {
            this.imgUrl = ''
            console.log(this.files)
            if(this.fileName == ""){
                this.$message.warning('请选择要上传的图片！')
                return false
            }
            let fileFormData = new FormData();
            //fileFormData.append('file',URL.createObjectURL(this.file9) );//filename是键，file是值，就是要传的文件，test.zip是要传的文件名
            fileFormData.append('file',this.files );
            // fileFormData.append('dm',this.form.dm );
            let config = {
                headers: {
                'Content-Type': 'multipart/form-data'
                },
            }

            this.$axios.post(this.baseUrl+`/login/uploadXcFile`,fileFormData, config)
            .then(res => {
                console.log(res.data)
                if(res.data.error == 0){
                    
                    console.log(res.data.filenewname)
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    this.imgUrl = res.data.filenewname
                }
            }).catch(err => {
                console.log(err)
                this.$message({
                    message: '上传失败',
                    type: 'error'
                });
            })
        },
        handleDelete(row){
            this.$confirm("您确认要删除这条记录吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                axios({
                    method: 'post',
                    url: this.baseUrl+`/login/getIdDel`,
                    data:{
                        id: row.id
                    },
                    headers: { 
                        "Content-Type": "application/json"
                    },
                }).then(res => {
                    if(res.data.code == 0 && res.data.data){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getList()
                    }else{
                        if(res.data.msg){
                            this.$message.error(res.data.msg)
                        }
                    }
                }).catch(error => {
                    this.$message.error(error);
                })   	
                    
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });			
        },
        onSubmit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let status = true;
                    if(this.form.ID){
                        axios({
                            method: 'post',
                            url: this.baseUrl+`/login/editYongxinxi`,
                            data:{
                                cmid: this.cmid,
                                id: this.form.ID,
                                dm: this.form.dm,
                                xm: this.form.xm,
                                xb: this.form.xb,
                                yhsf: this.form.yhsf,
                                zfzh: this.form.zfzh,
                                sfzh: this.form.sfzh,
                                txdz: '',
                                gzbm: this.form.gzbm,
                                zgqy: this.form.zgqy,
                                gzzw: this.form.gzzw,
                                zgfw: this.form.zgfw,
                                zt: this.form.zt,
                                em: this.form.em,
                                csrq: this.form.csrq,
                                sj1: this.form.sj1,
                                yhimgurl: this.imgUrl,
                            },
                            headers: { 
                                "Content-Type": "application/json"
                            },
                        }).then(res => {
                            console.log(res)
                            this.open = false
                            if(res.data.code == 0 ){
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                                this.getList()
                                
                            }else{
                                this.$message.error(res.data.msg)
                            }
                        }).catch(res => {
                            this.$message({
                                message: '修改失败',
                                type: 'error'
                            });
                        })
                    }else{
                        axios({
                            method: 'post',
                            url: this.baseUrl+`/login/saveYongXinxi`,
                            data:{
                                cmid: this.cmid,
                                id: '',
                                dm: this.form.dm,
                                xm: this.form.xm,
                                xb: this.form.xb,
                                yhsf: this.form.yhsf,
                                zfzh: this.form.zfzh,
                                sfzh: this.form.sfzh,
                                txdz: '',
                                gzbm: this.form.gzbm,
                                zgqy: this.form.zgqy,
                                gzzw: this.form.gzzw,
                                zgfw: this.form.zgfw,
                                zt: this.form.zt,
                                em: this.form.em,
                                csrq: this.form.csrq,
                                sj1: this.form.sj1,
                                yhimgurl: this.imgUrl,
                            },
                            headers: { 
                                "Content-Type": "application/json"
                            },
                        }).then(res => {
                            console.log(res)
                            this.open = false
                            if(res.data.code == 0 ){
                                this.$message({
                                    message: '新增成功',
                                    type: 'success'
                                });
                                this.getList()
                                
                            }else{
                                this.$message.error(res.data.msg)
                            }
                        }).catch(res => {
                            this.$message({
                                message: '新增失败',
                                type: 'error'
                            });
                        })
                    }
                }
            })
        },
    }
}
</script>


<style scoped>
</style>